const React = require('react');
const { createElement: h } = React;

// One <input> per missing required hyperparameter (Start params + custom
// node params). Saves all values in one shot via the parent's onSubmit so
// the QA flow can resume on the next tick.
function MissingFieldsDialog(props) {
  var fields = props.fields || [];
  var onSubmit = props.onSubmit || function() {};
  var onCancel = props.onCancel || function() {};
  var initial = {};
  fields.forEach(function(f) {
    initial[f.nodeId + '::' + f.paramKey] = f.currentValue == null ? '' : String(f.currentValue);
  });
  var [values, setValues] = React.useState(initial);

  React.useEffect(function() {
    function onKeyDown(e) {
      if (e.key === 'Escape') onCancel();
    }
    document.addEventListener('keydown', onKeyDown);
    return function() { document.removeEventListener('keydown', onKeyDown); };
  }, []);

  function setOne(key, val) {
    setValues(function(prev) {
      var next = Object.assign({}, prev);
      next[key] = val;
      return next;
    });
  }

  // Group by node so the user sees which node each field belongs to.
  var byNode = [];
  var byNodeIdx = {};
  fields.forEach(function(f) {
    if (byNodeIdx[f.nodeId] === undefined) {
      byNodeIdx[f.nodeId] = byNode.length;
      byNode.push({ nodeId: f.nodeId, nodeTitle: f.nodeTitle, kind: f.kind, items: [] });
    }
    byNode[byNodeIdx[f.nodeId]].items.push(f);
  });

  var allFilled = fields.every(function(f) {
    var v = values[f.nodeId + '::' + f.paramKey];
    return v != null && String(v).trim() !== '';
  });

  return h('div', { className: 'cdialog-overlay', onMouseDown: onCancel },
    h('div', {
      className: 'cdialog-box cdialog-box-wide',
      onMouseDown: function(e) { e.stopPropagation(); }
    },
      h('div', { className: 'cdialog-icon' },
        h('svg', { width: 22, height: 22, viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: 2, strokeLinecap: 'round', strokeLinejoin: 'round' },
          h('path', { d: 'M12 9v4m0 4h.01M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z' })
        )
      ),
      h('div', { className: 'cdialog-title' }, 'Provide info before running'),
      h('div', { className: 'cdialog-message' }, 'These required fields are still empty. Fill them in and we’ll start QA right after.'),
      h('div', { className: 'cdialog-fields' },
        byNode.map(function(group) {
          var prefix = group.kind === 'start-param' ? 'Start input' : 'Node input';
          return h('div', { key: group.nodeId, className: 'cdialog-fields-group' },
            h('div', { className: 'cdialog-fields-group-header' }, prefix + ' — ' + group.nodeTitle),
            group.items.map(function(f) {
              var k = f.nodeId + '::' + f.paramKey;
              var pt = String(f.paramType || 'string').toLowerCase();
              var inputType = pt === 'number' ? 'number' : (pt === 'datetime' ? 'datetime-local' : 'text');
              return h('label', { key: k, className: 'cdialog-field' },
                h('span', { className: 'cdialog-field-label' }, f.fieldLabel),
                pt === 'boolean'
                  ? h('select', {
                      className: 'cdialog-field-input',
                      value: String(values[k] || ''),
                      onChange: function(e) { setOne(k, e.target.value); }
                    },
                      h('option', { value: '' }, 'Select…'),
                      h('option', { value: 'true' }, 'true'),
                      h('option', { value: 'false' }, 'false')
                    )
                  : h('input', {
                      className: 'cdialog-field-input',
                      type: inputType,
                      value: values[k] || '',
                      placeholder: 'Enter ' + f.fieldLabel,
                      autoFocus: f === fields[0],
                      onChange: function(e) { setOne(k, e.target.value); }
                    })
              );
            })
          );
        })
      ),
      h('div', { className: 'cdialog-actions' },
        h('button', { className: 'cdialog-btn cdialog-btn-cancel', onClick: onCancel }, 'Cancel'),
        h('button', {
          className: 'cdialog-btn cdialog-btn-confirm',
          onClick: function() { if (allFilled) onSubmit(values); },
          disabled: !allFilled,
          title: allFilled ? '' : 'Fill in every field to continue'
        }, 'Save & Start QA')
      )
    )
  );
}

module.exports = MissingFieldsDialog;
